import {
  SMART_EDIT_GEO_FILTER_STATE_DATA_LOADING, 
  SMART_EDIT_GEO_FILTER_STATE_DATA_SUCCESS, 
  SMART_EDIT_GEO_FILTER_STATE_DATA_FAILURE,
  SMART_EDIT_GEO_FILTER_MARKET_DATA_LOADING,
  SMART_EDIT_GEO_FILTER_MARKET_DATA_SUCCESS,
  SMART_EDIT_GEO_FILTER_MARKET_DATA_FAILURE,
} from "@src/middleware/actions/actionTypes";


interface SmartEditsState {
  ediFilterStateData: any;
  ediFilterStateIsLoading: boolean;
  ediFilterStateError: string | null;
  ediFilterMarketData: any;
  ediFilterMarketIsLoading: boolean;
  ediFilterMarketError: string | null;
}

const initialState: SmartEditsState = {
  ediFilterStateData: {},
  ediFilterStateIsLoading: false,
  ediFilterStateError: null,
  ediFilterMarketData: {},
  ediFilterMarketIsLoading: false,
  ediFilterMarketError: null,
};

const EditfilterReducer = (
  state = initialState,
  action: { type: string; payload?: any }
): SmartEditsState => {
  switch (action.type) {
    case SMART_EDIT_GEO_FILTER_STATE_DATA_LOADING:
      return {
        ...state,
        ediFilterStateIsLoading: action.payload,
      };

    case SMART_EDIT_GEO_FILTER_STATE_DATA_SUCCESS:
      return {
        ...state,
        ediFilterStateData: action.payload,
      };

    case SMART_EDIT_GEO_FILTER_STATE_DATA_FAILURE:
      return {
        ...state,
        ediFilterStateError: action.payload,
      };

    case SMART_EDIT_GEO_FILTER_MARKET_DATA_LOADING:
      return {
        ...state,
        ediFilterMarketIsLoading: action.payload,
      };

    case SMART_EDIT_GEO_FILTER_MARKET_DATA_SUCCESS:
      return {
        ...state,
        ediFilterMarketData: action.payload,
      };

    case SMART_EDIT_GEO_FILTER_MARKET_DATA_FAILURE:
      return {
        ...state,
        ediFilterMarketError: action.payload,
      };

    default:
      return state;
  }
};

export default EditfilterReducer;
